import { AppConfig } from '@ltvco/refresh-lib/ctx';
import {
  Box,
  Text,
  Stack,
  CustomIcons,
  styled,
} from '@ltvco/refresh-lib/theme';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { FeatureCard } from '@ltvco/refresh-lib/v2';
import { Security } from '@mui/icons-material';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import DashboardDigitialFoorprint from '../DashboardPage/components/DashboardDigitialFoorprint';

const StyledStack = styled(Stack)(() => ({
  display: 'flex',
  alignItems: 'start',
}));

export function IdentityHub() {
  document.title = 'Identity Hub - BeenVerified';

  const { trackEvent } = useContext(AppConfig);
  const { isMobile } = useScreenSize();
  const navigate = useNavigate();

  const darkWebNavigation = () => {
    trackEvent('dark web', 'navigation click', 'identity hub');
    navigate('/dashboard/dark-web');
  };

  const unclaimedMoneyNavigation = () => {
    trackEvent('unclaimed money', 'navigation click', 'identity hub');
    navigate('/dashboard/unclaimed-money');
  };

  return (
    <>
      <StyledStack mb={2}>
        <Text variant="h1" sx={{ display: 'flex', alignItems: 'center' }}>
          {<Security sx={{ fontSize: '2rem', color: '#0052FF', mr: 2 }} />}{' '}
          Identity Hub
        </Text>

        <Text>Monitor your online identity with BeenVerified</Text>
      </StyledStack>

      <Stack flexDirection={isMobile ? 'column' : 'row'} gap={isMobile ? 0 : 2}>
        <FeatureCard
          action={darkWebNavigation}
          description="See if your information may have been leaked in a data breach"
          icon={<CustomIcons.CreditCardIcon sx={{ fontSize: '3.125rem' }} />}
          title="Dark web scan"
          width={isMobile ? '100%' : '50%'}
        />
        <FeatureCard
          action={unclaimedMoneyNavigation}
          description="See if you may be owed unclaimed money"
          icon={
            <CustomIcons.DollarsAndCoinsIcon sx={{ fontSize: '3.125rem' }} />
          }
          title="Unclaimed money"
          width={isMobile ? '100%' : '50%'}
        />
      </Stack>

      <Box display="flex" flexDirection="column" rowGap={2.5} marginBottom={2}>
        <DashboardDigitialFoorprint />
      </Box>
    </>
  );
}
